import { MolsonDxGrid } from '@components/reusable'
import { molsonStyled } from '@theme/customMuiExports'
export const RoundedDxGrid = molsonStyled(MolsonDxGrid)({
  '& .dx-datagrid': {
    backgroundColor: 'transparent !important'
  },
  '& .dx-datagrid-borders .dx-datagrid-rowsview, .dx-datagrid-headers+.dx-datagrid-rowsview, .dx-datagrid-rowsview.dx-datagrid-after-headers':
    {
      borderBottomWidth: '0.5px',
      borderRadius: '0 0 8px 8px'
    }
})
